import { render, staticRenderFns } from "./aftersaledetail.vue?vue&type=template&id=3eee0ad3&scoped=true"
import script from "./aftersaledetail.vue?vue&type=script&lang=js"
export * from "./aftersaledetail.vue?vue&type=script&lang=js"
import style0 from "./aftersaledetail.vue?vue&type=style&index=0&id=3eee0ad3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eee0ad3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eee0ad3')) {
      api.createRecord('3eee0ad3', component.options)
    } else {
      api.reload('3eee0ad3', component.options)
    }
    module.hot.accept("./aftersaledetail.vue?vue&type=template&id=3eee0ad3&scoped=true", function () {
      api.rerender('3eee0ad3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mall/aftersaledetail.vue"
export default component.exports